import { Truck, RotateCcw, Globe, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";

export default function ShippingReturns() {
  return (
    <div className="max-w-4xl mx-auto px-5 sm:px-8 py-12" data-testid="shipping-returns-page">
      <p className="overline mb-3">Customer promise</p>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mb-10">
        Shipping & returns
      </h1>

      <section className="mb-12">
        <h2 className="font-display text-lg font-bold mb-4 flex items-center gap-2">
          <Truck size={20} className="text-brand" /> Shipping rates
        </h2>
        <div className="border border-ink/10 rounded-md overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-secondary text-left text-xs uppercase tracking-wide">
              <tr>
                <th className="p-3">Destination</th>
                <th className="p-3">Flat rate</th>
                <th className="p-3">Free shipping</th>
                <th className="p-3">Typical delivery</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-t border-ink/5">
                <td className="p-3 font-medium">New Zealand & Australia</td>
                <td className="p-3 font-mono">$9.99</td>
                <td className="p-3">Orders over $75</td>
                <td className="p-3">10–21 business days</td>
              </tr>
              <tr className="border-t border-ink/5">
                <td className="p-3 font-medium">Rest of the world</td>
                <td className="p-3 font-mono">$24.99</td>
                <td className="p-3">Orders over $250</td>
                <td className="p-3">14–28 business days</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="text-sm text-muted-foreground mt-3">
          Every order gets a confirmation email, and you can follow progress anytime on our{" "}
          <Link to="/track" className="underline font-medium hover:text-brand">Track Order</Link> page.
        </p>
      </section>

      <section className="mb-12">
        <h2 className="font-display text-lg font-bold mb-4 flex items-center gap-2">
          <Globe size={20} className="text-brand" /> Taxes & duties
        </h2>
        <ul className="space-y-2 text-sm text-muted-foreground list-disc pl-5">
          <li>NZ GST (15%) and AU GST (10%) are calculated and shown at checkout — no surprises on delivery.</li>
          <li>For other countries, local VAT/sales tax is applied at checkout where required.</li>
          <li>Some international orders may attract import duties set by your local customs — these are the buyer's responsibility.</li>
        </ul>
      </section>

      <section className="mb-12">
        <h2 className="font-display text-lg font-bold mb-4 flex items-center gap-2">
          <RotateCcw size={20} className="text-brand" /> Returns & exchanges
        </h2>
        <ul className="space-y-2 text-sm text-muted-foreground list-disc pl-5">
          <li><strong className="text-ink">30-day returns</strong> — if it's not right, send it back within 30 days of delivery for a refund or exchange.</li>
          <li>Items must be unworn, unwashed and in original condition.</li>
          <li><strong className="text-ink">Wrong size?</strong> We exchange for free — just cover return postage. Check our size guide on each product page before ordering.</li>
          <li>Damaged or faulty item? We'll replace it or refund you in full, including postage — photos help us fix it fast.</li>
          <li>To start a return, use the <Link to="/contact" className="underline font-medium hover:text-brand">contact form</Link> or the chat concierge with your order ID.</li>
        </ul>
      </section>

      <section className="bg-ink text-white rounded-md p-8">
        <h2 className="font-display text-lg font-bold mb-3 flex items-center gap-2">
          <ShieldCheck size={20} className="text-brand" /> Our guarantee
        </h2>
        <p className="text-sm text-white/70 leading-relaxed">
          Shop with confidence: secure card checkout, GST handled for NZ & AU, tracked worldwide delivery
          and real support 7 days a week. If anything goes wrong with your order, Go Big Forever will make it right.
        </p>
      </section>
    </div>
  );
}
